import React from 'react'
import './shift'

import './background.scss'

function Background() {

    return (
        <div className="background__content background__content--canvas">
            <h2 className="background__content__title">Shift</h2>
        </div>
    );
}

export default Background;
